export default {
  "info-shop-layout": () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/shop/src/layouts/info-shop-layout.vue"),
  "main-shop-layout": () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/shop/src/layouts/main-shop-layout.vue"),
  "shop-layout": () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/shop/src/layouts/shop-layout.vue")
}